class BirthDateField extends HTMLElement {
  constructor() {
    super();

    const { mask, autofillChars } = this.dataset;
    this.mask = mask;
    this.autofillChars = autofillChars.split('');
    this.inputName = this.getAttribute('name');
    this.dateMax = this.getAttribute('max');
    this.dateMin = this.getAttribute('min') || '1800-01-01';
    this.placeholderPrefix = this.getAttribute('placeholder');
  
    const [autofillIndices, userInputIndices] = this.mask.split('').reduce((splitArray, char, i) => {
      const autofillChar = this.autofillChars.includes(char);
      splitArray[autofillChar ? 0 : 1].push(i);
      return splitArray;
    }, [[],[]]);
    this.autofillIndices = autofillIndices;
    this.lastUserInputIndex = userInputIndices[userInputIndices.length - 1];

    this.overlaySpacerText = '';
    this.overlayGuideText = this.mask;

    this.lastValue = '';

    this.inputCompleted = false;

    // Inject HTML
    this.render();

    // Set up refs
    this.userInput = this.querySelector('input[type="text"]');
    this.dateInput = this.querySelector('input[type="date"]');
    this.overlaySpacer = this.querySelector('.overlay_spacer');
    this.overlayGuide = this.querySelector('.overlay_guide');

    // Set up event listeners
    this.listen();
  }

  splice(string, char, index) {
    return `${ string.slice(0, index) }${ char }${ string.slice(index) }`;
  }

  setDate(val) {
    // A hidden date input stores the actual date, and will submit if a form is submitted instead of the nameless user input.
    this.dateInput.value = this.inputToDate(val ? val : this.userInput.value);    
    const valid = this.dateInput.checkValidity();
    // console.log(valid);
  }

  inputToDate(input) {
    // Use the provided format to find where to get day, month and year from. Not ideal that it's hardcoded, but that's what we got.
    const yearIndex = this.mask.indexOf('YYYY');
    const monthIndex = this.mask.indexOf('MM');
    const dayIndex = this.mask.indexOf('DD');

    const dateValue = `${ input.slice(yearIndex, yearIndex + 4) }-${ input.slice(monthIndex, monthIndex + 2) }-${ input.slice(dayIndex, dayIndex + 2) }`;

    // console.log(dateValue);
    return dateValue;
  }

  onInput(e) {
    const inputEl = e.target;

    const currentValue = inputEl.value;
    let editedValue = currentValue;
    // let positionAdjustment = 0;
    let charsFilled = 0;

    const cursorPosition = inputEl.selectionStart;
    let pushCursor = 0;

    if (currentValue.length > this.lastValue.length) {
      // Going forwards - autofill characters. 
      // Don't autofill as people backspace or that'd be weird.

      for (const i of this.autofillIndices) {
        // console.log(i + 1, editedValue.length, editedValue[i + positionAdjustment], this.mask[i]);
        
        const calculatedCursor = cursorPosition + charsFilled;
        
        // We're calculating a new text with autofilled characters. When we autofill a character, the text is longer, and the cursor moves forward. However, we don't want to autofill characters ahead of where the user is typing. So if where the cursor will be is behind where the next character is, stop autofilling. Also, keep track of any characters inserted behind the cursor, to adjust it forwards.
        // Oh and autofill characters ahead of the cursor if they're at the end.
        if (calculatedCursor < i + 1 && calculatedCursor <= this.lastUserInputIndex) {
          // console.log('break');
          break;
        }
        
        const inputChar = editedValue[i + charsFilled];
        const maskChar = this.mask[i];
        if (inputChar !== maskChar) {
          editedValue = this.splice(editedValue, maskChar, i);
          ++charsFilled;
          if (i <= calculatedCursor) {
            ++pushCursor;
          }
        }
      }
    }

    // Update overlay with current content
    this.overlaySpacerText = editedValue;
    this.renderOverlay();

    this.setDate(editedValue);
    // Set the input value if needed
    if (editedValue !== currentValue) {
      inputEl.value = editedValue;
      inputEl.setSelectionRange(cursorPosition + pushCursor, cursorPosition + pushCursor);
    }

    const inputCompleted = editedValue.length === parseInt(inputEl.getAttribute('maxlength'));
    // This class aids in only showing validity errors once the user is done with their input.
    this.classList.toggle('_input_completed', inputCompleted);
    if (inputCompleted) {
      this.inputCompleted = true;
      // If the user submits a form, apply _submit_attempted to the field. Once they've corrected their input and it's full, remove the class.
      this.classList.remove('_submit_attempted');
    }

    this.lastValue = editedValue;
  }

  render() {
    this.innerHTML = `
      <input class="hidden_input" type="date" name="${ this.inputName }" max="${ this.dateMax }" min="${ this.dateMin }" required>
      <div class="masked_input_wrapper">
        <div class="masked_input">
          <input id="birthday" type="text" autocomplete="bday" maxlength="${ this.mask.length }" placeholder="${ this.placeholderPrefix ? `${ this.placeholderPrefix } ` : '' }${ this.mask }">
          <div class="bdf_overlay">
            ${ this.placeholderPrefix ? `<span class="overlay_prefix">${ this.placeholderPrefix } </span>` : '' }
            <span class="overlay_spacer">${ this.overlaySpacerText }</span>
            <span class="overlay_guide">${ this.overlayGuideText }</span>
          </div>
        </div>
      </div>
    `;
  }

  listen() {
    // Add event listeners
    this.userInput.addEventListener('input', e => this.onInput(e));
  }

  renderOverlay() {
    this.overlaySpacer.innerHTML = this.overlaySpacerText;
    this.overlayGuide.innerHTML = this.mask.slice(this.overlaySpacerText.length);
  }
}

// Define the custom element
customElements.define('birth-date-field', BirthDateField);